import { errorToast } from "@/v2-ui/toast"
import {
  type ConfirmButtonProps,
  ConfirmButton,
} from "@/v2-backoffice-client/components/button"
import { useLayerCountDriftAcceptMutation } from "@/v2-backoffice-client/layer/drift/accept/layer.countDrift.accept.mutation"

export type LayerCountDriftAcceptButtonProps = Omit<
  ConfirmButtonProps,
  "onConfirm"
> & {
  source: string
  identifier: string
  onCompleted?(): void
}

// LayerCountDriftAcceptButton promotes the live feature count to be
// the new baseline. Sibling of LayerDriftAcceptButton; we keep the two
// actions distinct so an operator can baseline a count change they've
// investigated while leaving metadata drift alive on the same target
// (or vice versa).
function LayerCountDriftAcceptButton(props: LayerCountDriftAcceptButtonProps) {
  const { source, identifier, onCompleted, children, ...rest } = props

  const [acceptCountBaseline, { loading, error }] =
    useLayerCountDriftAcceptMutation({ onCompleted })

  errorToast(error, {
    title: "Failed to accept current count as the new baseline",
  })

  return (
    <ConfirmButton
      variant="primary"
      iconSrc="check"
      content="Accept current count as baseline"
      confirmContent="This replaces the stored count baseline with the live feature count. The count-drift indicator will clear until the next snapshot drops below the warning band again."
      isLoading={loading}
      onConfirm={() => {
        acceptCountBaseline({
          variables: { input: { source, identifier } },
        })
      }}
      {...rest}
    >
      {children ?? "Accept current count as baseline"}
    </ConfirmButton>
  )
}

export default LayerCountDriftAcceptButton
